<button *ngIf="!isVideoOpen" (click)="photoStart()" class="button">Show Camera</button>
<div [class.is-hidden]="!isVideoOpen">
    <video #video width="640" height="480" autoplay></video>
</div>
<button *ngIf="isVideoOpen" (click)="photoSnap()" class="button">Take Picture</button>
<br><br>
<div [class.is-hidden]="!isSnapTaken">
    <canvas #canvas style="width: 14em;" width="640" height="480"></canvas>
</div>